export type TNativeAudioDestinationNode = AudioDestinationNode;
